<script>
  export let location, open, locationAvailable;
</script>

<div class="overlay">
  <div class="card modal">
    <h6>Settings</h6>
    <p>Having trouble?</p>
    <p><a href="https://docs.google.com/forms/d/e/1FAIpQLSdmwyYykVzwX0ga_EjwRuuiOvFI6aNtlxX9pHdPrc_hD9Kzyw/viewform">Report A Bug</a></p>
    <a href='https://ko-fi.com/M4M81JYWQ' target='_blank'><img height='36' style='border:0px;width:142px;height:36px;' src='https://cdn.ko-fi.com/cdn/kofi1.png?v=2' border='0' alt='Buy Me a Coffee at ko-fi.com' /></a>
    <p class="caption">
      Map tiles by <a href="http://stamen.com/">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org/">OpenStreetMap</a>, under <a href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a> & <a href="http://www.openstreetmap.org/copyright">ODbL</a>.
    </p>
  </div>

</div>

<style>
  .modal {
    width: 70vw;
    margin: 80px 10vw;
  }

  h6 {
    margin: 0 0 15px 0;
  }

  .overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1100;
    background-color: rgba(32, 32, 32, 0.7)
  }
</style>
